import React from 'react';

export const GenericIcon = ({
  size = 24,
  svgPath,
  ...rest
}: {
  size?: number;
  svgPath: string;
}): JSX.Element => {
  return (
    <svg
      focusable="false"
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="currentColor" d={svgPath} />
    </svg>
  );
};
